import React from 'react';

const Project = () => {

  const projects = [
    { name: '', image: 'images/project1.jpg', linkImage:'https://skincancerwebapp.web.app/', link1: 'https://drive.google.com/file/d/1OkXmfx7grFf7NmEnsDd6A9MwXhyFysMh/view?usp=sharing', link2: 'https://github.com/itsanjalich/Skincancer.git' },
    { name: '', image: 'images/project2.jpg', linkImage: 'https://geeksmoon-d853a.web.app/', link2: 'https://github.com/itsanjalich/my-edusite.git'  },
    { name: '', image: 'images/project3.jpg', linkImage: 'https://quickrecapi.web.app/', link2: 'https://github.com/itsanjalich/quicrecapi.git' },
    { name: '', image: 'images/project4.jpg', linkImage:'https://netgain-5a14e.web.app/',link1: 'https://drive.google.com/file/d/1HPt9y9URi3ERVXUEzxj_4VWeKpOwJZCw/view?usp=sharing', link2: 'https://github.com/itsanjalich/NetGain.git' },
    { name: '', image: 'images/project5.jpg', linkImage:'https://grocifywebapp.web.app/', link1: 'https://drive.google.com/file/d/1kby4G1n31eZnC3OVzcLPVxfoJQc3MZkp/view?usp=sharing', link2: 'https://github.com/itsanjalich/grocify.git' },
    { name: '', image: 'images/project6.jpg', link1: '', link2: '' },
  ];

  return (
    <section id="projects" className="projects">
      <h1 className="projects-title" style={{ color: "black", fontSize: "60px", textAlign: "center", margin: "0 auto", marginBottom: "20px" }}>
        Projects
      </h1>
      <div className="project-container">
        {projects.map(project => (
          <div key={project.link1} className="project-box">
            {project.linkImage && (
              <a href={project.linkImage} target="_blank" rel="noopener noreferrer">
                <img src={project.image} alt={project.name} />
              </a>
            )}
            {!project.linkImage && (
              <img src={project.image} alt={project.name} />
            )}
            {project.name && (
              <h3>{project.name}</h3>
            )}
            <div className="project-links">
              {project.link1 && (
                <a href={project.link1} target="_blank" rel="noopener noreferrer">
                  <button>Demo</button>
                </a>
              )}
              <a href={project.link2} target="_blank" rel="noopener noreferrer">
                <button>Git</button>
              </a>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Project;
